import { ReactNode } from 'react';
import { useModal } from 'react-modal-hook';
import { useTranslation } from 'react-i18next';

import UI from './UI';

interface UseConfirmModalProps {
  title?: ReactNode;
  body?: ReactNode;
  disabled?: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
}

const useConfirmModal = ({
  title, body, disabled, onConfirm, onCancel,
}: UseConfirmModalProps, dependencies?: any[]) => {
  const { t } = useTranslation('common');

  const [openModal, closeModal] = useModal(() => (
    <UI.Modal close={closeModal}>
      <UI.GridContainer>
        {title && (
          <UI.H4 style={{ paddingRight: 30 }}>
            {title}
          </UI.H4>
        )}
        <UI.Div>
          {body || t('confirm_modal.default_message')}
        </UI.Div>
        <UI.HR />
        <UI.Div sc={{ textAlign: 'right' }}>
          <UI.Button onClick={() => { onCancel?.(); closeModal(); }}>
            {t('cancel')}
          </UI.Button>
          {' '}
          <UI.Button
            onClick={() => { onConfirm(); closeModal(); }}
            disabled={disabled}
            sc={{ brand: 'secondary' }}
          >
            {t('confirm')}
          </UI.Button>
        </UI.Div>
      </UI.GridContainer>
    </UI.Modal>
  ), dependencies);

  return [openModal, closeModal];
};

export default useConfirmModal;
